
import { ArrayHelper } from "../../../utilities/contracts/array-helper";
import { StringHelper } from "../../../utilities/contracts/string-helper";
import { DynamicInput, IDynamicInputOptions } from "../dynamic-input.model";
import { SelectableInput } from "../selectable-input.model";
import { MultiselectComponent } from "./multiselect.component";

export interface IMulitselect extends IDynamicInputOptions {
  placeholder?: string;
  options?: SelectableInput[];
  maxSelectedLabels?: number;
}

export class Multiselect extends DynamicInput implements IMulitselect {
  filter: boolean;
  options: SelectableInput[];
  hidden: boolean;
  selectedOptions: SelectableInput[];
  maxSelectedLabels: number;
  placeholder: string;

  readonly controlType = "multiselect";
  readonly componentType = MultiselectComponent;

  constructor(options: IMulitselect = {}) {
    super(options);
    this.placeholder = StringHelper.clean(options.placeholder);
    this.options = ArrayHelper.isAvailable(options.options) ? options.options : [];
    this.selectedOptions = options.value || [];
    this.maxSelectedLabels = options.maxSelectedLabels || 3;
  }
}
